export enum AttributeWarning {
	NO_VALUES = 'noValuesWarning',
	SPARSE = 'sparseWarning',
	UNIQUE = 'uniqueWarning'
}